import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import VuexPersistence from 'vuex-persist/dist/umd';
import appState from './modules/appState';
import configurationState from '@/store/modules/configurationState';
import { RootState } from './types';

// Use the notification module from Vue Dot
import { notification } from '@cnamts/vue-dot/src/modules/notification';

/** The store is saved in the browser's session */
const vuexLocal = new VuexPersistence();

Vue.use(Vuex);

/** See https://vuex.vuejs.org/fr/getting-started.html for help */
const store: StoreOptions<RootState> = {
	strict: true,
	state: {},
	// See https://vuex.vuejs.org/guide/modules.html for more info on modules
	modules: {
		appState,
		configurationState,
		notification
	},
	plugins: [
		vuexLocal.plugin
	]
};

export default new Vuex.Store<RootState>(store);
